export class LoadTarget {
  public targetId: string;
  private counter: number;

  public _isLoading: boolean;

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public loadStart() {
    if (this.counter == 0) {
      this._isLoading = true;
    }
    this.counter++;
  }

  public loadComplete() {
    if (this.counter == 1) {
      this._isLoading = false;
    }
    this.counter--;
  }

  constructor(targetId: string) {
    this.targetId = targetId;
    this.counter = 0;
    this._isLoading = false;
  }
}
